import Immutable from 'immutable';

// constants
import {
  DOCTOR_AVAILABILITIES_FETCH_FOR_OFFICE,
  DOCTOR_CREATE,
  DOCTOR_DELETE,
  DOCTOR_EDIT,
  DOCTOR_LIST_FETCH,
  DOCTOR_LIST_FETCH_FOR_OFFICE
} from '../constants/doctorTypes';

// lib
import httpReducer from '../lib/httpReducer';
import { callbackHandler, merge, remove, replace } from '../lib/mapReducerHelpers';

export default function(state = Immutable.Map(), action) {
  switch (action.type) {
    case DOCTOR_AVAILABILITIES_FETCH_FOR_OFFICE:  return httpReducer(state, action, callbackHandler(merge, 'doctor'));
    case DOCTOR_CREATE:                           return httpReducer(state, action, callbackHandler(replace, 'doctor'));
    case DOCTOR_DELETE:                           return httpReducer(state, action, callbackHandler(remove, 'doctor'));
    case DOCTOR_EDIT:                             return httpReducer(state, action, callbackHandler(replace, 'doctor'));
    case DOCTOR_LIST_FETCH:                       return httpReducer(state, action, callbackHandler(merge, 'doctor'));
    case DOCTOR_LIST_FETCH_FOR_OFFICE:            return httpReducer(state, action, callbackHandler(merge, 'doctor'));
    default:                                      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/doctor.js